
import { doExportReportReport } from '@/api/enterprise'
import { mapGetters } from 'vuex'
export default {
  props: ['rendered', 'project_id', 'project_name', 'isAdd'],
  data() {
    return {
      canClick: true,
      isLoading: false
    }
  },
  
 computed: {
    ...mapGetters(['vip'])
  },
  methods: {
    showLoading() {
      this.isLoading = true
    },
    hideLoading() {
      this.isLoading = false
    },
    downloadURL(url,fileName) {
        const a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.pptx`; // 为 `download` 属性设置一个空字符串会使文件使用原始文件名
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    },
    async btnClick() {  
      if (!this.canClick) {
          return; // 阻止重复点击
      }

      this.canClick = false;
      setTimeout(() => {
          this.canClick = true;
      }, 1500);
      if (!this.vip || this.vip.status != 'active') {
        $('#updrage').click()
        return $('#doNotProjectReportPanelBtn').click()
      }
      if (this.isLoading) {
        return this.$toasted.show('报告未下载完毕，请耐心等待', {position: "top-center", duration: 500})
      } 
      if (this.isAdd) {
        this.$emit('exportingPPTX', true) 
      }
      if (this.project_id) {
          this.isLoading = true      
          this.$store.commit('app/SET_PROJECT_ID', this.project_id)  
          const res = await doExportReportReport({project_id: this.project_id, format: 'pptx'})
          this.isLoading = false      
          if (res.code == 0) {
            fetch(process.env.NODE_ENV === "dev" ?  res.data.url.replace('https://cyy.pcmxj.com', '/json') : res.data.url)        
            .then(response => response.blob())
            .then(blob => {          
              saveAs(blob, `${this.project_name}.pptx`);
            });
          }
      } 
    },
  }
}
